import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import { Spinner, PageLoader } from '../components/common/Loader';
import NetworkGuard from '../components/common/NetworkGuard';
import ActivityLog from '../components/activity/ActivityLog';

export default function ActivityPage() {
  const { isConnected, connect, connecting } = useWallet();
  const { activities, refresh, isRegistered, loading } = useUserData();
  const navigate = useNavigate();

  if (!isConnected) {
    return (
      <div className="container activity-page">
        <div className="empty-state">
          <div className="icon">🔒</div>
          <h3 style={{ marginBottom: 8 }}>Connect Your Wallet</h3>
          <button className="btn btn-primary btn-lg mt-4" onClick={connect} disabled={connecting}>
            {connecting ? <><Spinner /> Connecting</> : 'Connect Wallet'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <NetworkGuard>
      <div className="container activity-page">
        {loading ? (
          <PageLoader label="LOADING ACTIVITY" sub="Fetching event history..." />
        ) : !isRegistered ? (
          <div className="empty-state">
            <div className="icon">📝</div>
            <h3>Please Register First</h3>
            <button className="btn btn-primary btn-lg mt-4" onClick={() => navigate('/register')}>
              Register Now →
            </button>
          </div>
        ) : (
          <>
            <div className="dashboard-header">
              <div>
                <div className="section-eyebrow">HISTORY</div>
                <h1>Recent <span className="text-gradient">Activity</span></h1>
                <p style={{ color: 'var(--text-muted)', fontSize: 14, marginTop: 6 }}>
                  Latest 50 events on your account
                </p>
              </div>
              <button className="btn btn-secondary btn-sm" onClick={refresh}>↻ Refresh</button>
            </div>
            <ActivityLog activities={activities} />
          </>
        )}
      </div>
    </NetworkGuard>
  );
}
